import { Outlet } from "react-router-dom";
import Header from "./Header"
import Menu from "./Menu"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"

function Layout() {

	return (
		<div className="Layout vh-100 h-100 d-flex justify-content-center align-items-bottom">
			<Container fluid>
				<Row className="justify-content-center align-items-center vh-100 h-100">
					<Col xs={12} md={12} lg={6} className="bg-light text-center vh-100 h-100 ">
						<Header />
						<Outlet/>
						<Menu />
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default Layout;
